import "./Modal.scss";

export {
  Modal,
  ModalDialog,
  useModalDialogContext,
  ModalHost,
  ModalService,
} from "@sportal/cdk";
